import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "wrapper2" }
const _hoisted_2 = { style: {"background":"rgb(255, 255, 255)","min-width":"348px","padding":"20px","margin":"0px -10px","min-height":"450px"} }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"introduction\"><h2 class=\"tc\">自测评量表导语</h2><p>①.自测前请认真阅读本说明内容，按答题方法进行操作；</p><p>②.此项测评<b>不具备医学评估作用或意义</b>，如感觉自己存在心理疾病，请到正规医院进行检测与诊治；</p><p>③.要求被测评人对自测结果能接受，并在评估过程能合作，要求其实事求是地答复每一个问题；</p><p>④.本功能只为互助成长，我愿与您在缘梦中共同成长。</p><h3 class=\"tc\">[关于量表]</h3><p>多伦多述情障碍量表（Toronto Alexithymia Scale,TAS-26）为自评式临床量表。U. J.泰勒等1984年编制。含26个项目，每个项目分五级评分。分为四个因子:因子I表示描述情感的能力;因子n表示认识和区别情绪及躯体感受的能力;因子flI表示缺乏幻想;因子N表示缺乏表露内在态度和欲念的能力，执著于外界事物的细枝末节。可较全面地评估述情障碍的存在及严重程度，经检验具有较高的信度和效度，应用较广泛。20世纪90年代初被介绍到国内。</p><h3 class=\"tc\">[本表操作方法]</h3><p>1.量表类型：<b>相对量表</b>（即多人测评下的相对分值）</p><p>2.本自测评量表需要具备<b>初中以上文化程度</b>。在受评者不受环境干扰下，一次性完成。</p><p>3.题目总数：<b>26题 </b></p><p>4.题目形式：<b>单选题 ABCDE</b></p><p>5.是否必须解读：<b>完成后即显示结果(非求助不解读)</b></p></div>", 1)
const _hoisted_4 = { class: "tc introductionp" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "tc" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "Qus" }
const _hoisted_10 = { class: "tc" }
const _hoisted_11 = { class: "Qus" }
const _hoisted_12 = { class: "tc" }
const _hoisted_13 = { class: "Qus" }
const _hoisted_14 = { class: "tc" }
const _hoisted_15 = { class: "Qus" }
const _hoisted_16 = { class: "tc" }
const _hoisted_17 = { class: "Qus" }
const _hoisted_18 = { class: "tc" }
const _hoisted_19 = { class: "Qus" }
const _hoisted_20 = { class: "tc" }
const _hoisted_21 = { class: "Qus" }
const _hoisted_22 = { class: "tc" }
const _hoisted_23 = { class: "Qus" }
const _hoisted_24 = { class: "tc" }
const _hoisted_25 = { class: "Qus" }
const _hoisted_26 = { class: "tc" }
const _hoisted_27 = { class: "Qus" }
const _hoisted_28 = { class: "tc" }
const _hoisted_29 = { class: "Qus" }
const _hoisted_30 = { class: "tc" }
const _hoisted_31 = { class: "Qus" }
const _hoisted_32 = { class: "tc" }
const _hoisted_33 = { class: "Qus" }
const _hoisted_34 = { class: "tc" }
const _hoisted_35 = { class: "Qus" }
const _hoisted_36 = { class: "tc" }
const _hoisted_37 = { class: "Qus" }
const _hoisted_38 = { class: "tc" }
const _hoisted_39 = { class: "Qus" }
const _hoisted_40 = { class: "tc" }
const _hoisted_41 = { class: "Qus" }
const _hoisted_42 = { class: "tc" }
const _hoisted_43 = { class: "Qus" }
const _hoisted_44 = { class: "tc" }
const _hoisted_45 = { class: "Qus" }
const _hoisted_46 = { class: "tc" }
const _hoisted_47 = { class: "Qus" }
const _hoisted_48 = { class: "tc" }
const _hoisted_49 = { class: "Qus" }
const _hoisted_50 = { class: "tc" }
const _hoisted_51 = { class: "Qus" }
const _hoisted_52 = { class: "tc" }
const _hoisted_53 = { class: "Qus" }
const _hoisted_54 = { class: "tc" }
const _hoisted_55 = { class: "Qus" }
const _hoisted_56 = { class: "tc" }
const _hoisted_57 = { class: "Qus" }
const _hoisted_58 = { class: "tc" }
const _hoisted_59 = { class: "Qus" }
const _hoisted_60 = { class: "tc" }
const _hoisted_61 = {
  key: 0,
  class: "okSuccess"
}
const _hoisted_62 = {
  key: 0,
  class: "tc yeButtom"
}
const _hoisted_63 = { class: "tc ye" }
const _hoisted_64 = { style: {"background":"rgb(255, 255, 255)","min-width":"348px","padding":"20px","margin":"0px -10px","min-height":"450px"} }
const _hoisted_65 = { class: "success ts" }
const _hoisted_66 = /*#__PURE__*/_createStaticVNode("<h2 class=\"tc\">述情障碍自测结果</h2><p class=\"shuoming tc\"><span class=\"yang\">“↑”为阳性</span>、<span class=\"ying\">“↓”为阴性</span>、<span class=\"shuoming\">“n”为常模数值</span></p>", 2)
const _hoisted_68 = {
  border: "1",
  class: "sutable"
}
const _hoisted_69 = {
  width: "360",
  colspan: "3",
  class: "fentitle"
}
const _hoisted_70 = { rowspan: "3" }
const _hoisted_71 = { width: "40" }
const _hoisted_72 = {
  width: "300",
  class: "shuoming tl"
}
const _hoisted_73 = {
  key: 0,
  class: "yang"
}
const _hoisted_74 = {
  key: 1,
  class: "ying"
}
const _hoisted_75 = {
  colspan: "3",
  class: "fentitle"
}
const _hoisted_76 = { class: "shuoming tl" }
const _hoisted_77 = {
  key: 0,
  class: "yang"
}
const _hoisted_78 = {
  key: 1,
  class: "ying"
}
const _hoisted_79 = {
  colspan: "3",
  class: "fentitle"
}
const _hoisted_80 = { class: "shuoming tl" }
const _hoisted_81 = {
  key: 0,
  class: "yang"
}
const _hoisted_82 = {
  key: 1,
  class: "ying"
}
const _hoisted_83 = {
  colspan: "3",
  class: "fentitle"
}
const _hoisted_84 = { class: "shuoming tl" }
const _hoisted_85 = {
  key: 0,
  class: "yang"
}
const _hoisted_86 = {
  key: 1,
  class: "ying"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_col = _resolveComponent("a-col")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", _hoisted_4, [
        _createVNode(_component_a_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSuccess(2))),
          disabled: _ctx.formState.disabled==0? false:true
        }, {
          default: _withCtx(() => [
            (_ctx.formState.disabled==0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "已阅读导语并同意内容，立即进入评估"))
              : _createCommentVNode("", true),
            (_ctx.formState.disabled>0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "阅读导语（" + _toDisplayString(_ctx.formState.disabled) + "）", 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ], 512), [
      [_vShow, _ctx.formState.onSuccess==1]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_a_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleList(1))),
          class: "buttonList"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.formState.sum>10?'ok':'')
            }, _toDisplayString(_ctx.formState.sum>10?'完成√':'1-10'), 3)
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleList(2))),
          disabled: _ctx.formState.sum>=10? false:true,
          class: "buttonList"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.formState.sum>20?'ok':'')
            }, _toDisplayString(_ctx.formState.sum>20?'完成√':'11-20'), 3)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_a_button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleList(3))),
          disabled: _ctx.formState.sum>=20? false:true,
          class: "buttonList"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.formState.sum>=26?'ok':'')
            }, _toDisplayString(_ctx.formState.sum>=26?'完成√':'21-26'), 3)
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      (_ctx.formState.list==1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_a_tabs, {
              activeKey: _ctx.formState.activeKey,
              "onUpdate:activeKey": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.formState.activeKey) = $event)),
              type: "line",
              size: "small",
              tabBarGutter: 25,
              centered: true,
              style: {"background":"rgb(255, 255, 255)","min-width":"348px","padding":"20px","margin":"0px -10px","min-height":"450px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_component_a_tab_pane, {
                  key: 1,
                  tab: "1",
                  disabled: _ctx.formState.sum>=1? false:true
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.formState.ques[1]), 1),
                      _createVNode(_component_a_radio_group, {
                        value: _ctx.formState.string[1],
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.string[1]) = $event)),
                        class: "QusRadio",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleSum(1)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 5
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("完全不同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 4
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("基本不同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 3
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("既不同意也不反对")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 2
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("基本同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 1
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("完全同意")
                            ]),
                            _: 1
                          }, 8, ["style"])
                        ]),
                        _: 1
                      }, 8, ["value"]),
                      _createElementVNode("p", _hoisted_10, [
                        (_ctx.formState.string[1]!=null)
                          ? (_openBlock(), _createBlock(_component_a_button, {
                              key: 0,
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleSum(1)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("下一题")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["disabled"])),
                (_openBlock(), _createBlock(_component_a_tab_pane, {
                  key: 2,
                  tab: "2",
                  disabled: _ctx.formState.sum>=2? false:true
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.formState.ques[2]), 1),
                      _createVNode(_component_a_radio_group, {
                        value: _ctx.formState.string[2],
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formState.string[2]) = $event)),
                        class: "QusRadio",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleSum(2)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 1
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("完全不同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 2
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("基本不同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 3
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("既不同意也不反对")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 4
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("基本同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 5
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("完全同意")
                            ]),
                            _: 1
                          }, 8, ["style"])
                        ]),
                        _: 1
                      }, 8, ["value"]),
                      _createElementVNode("p", _hoisted_12, [
                        (_ctx.formState.string[2]!=null)
                          ? (_openBlock(), _createBlock(_component_a_button, {
                              key: 0,
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleSum(2)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("下一题")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["disabled"])),
                (_openBlock(), _createBlock(_component_a_tab_pane, {
                  key: 3,
                  tab: "3",
                  disabled: _ctx.formState.sum>=3? false:true
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.formState.ques[3]), 1),
                      _createVNode(_component_a_radio_group, {
                        value: _ctx.formState.string[3],
                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formState.string[3]) = $event)),
                        class: "QusRadio",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleSum(3)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 1
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("完全不同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 2
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("基本不同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 3
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("既不同意也不反对")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 4
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("基本同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 5
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("完全同意")
                            ]),
                            _: 1
                          }, 8, ["style"])
                        ]),
                        _: 1
                      }, 8, ["value"]),
                      _createElementVNode("p", _hoisted_14, [
                        (_ctx.formState.string[3]!=null)
                          ? (_openBlock(), _createBlock(_component_a_button, {
                              key: 0,
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleSum(3)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("下一题")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["disabled"])),
                (_openBlock(), _createBlock(_component_a_tab_pane, {
                  key: 4,
                  tab: "4",
                  disabled: _ctx.formState.sum>=4? false:true
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.formState.ques[4]), 1),
                      _createVNode(_component_a_radio_group, {
                        value: _ctx.formState.string[4],
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formState.string[4]) = $event)),
                        class: "QusRadio",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleSum(4)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 1
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("完全不同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 2
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("基本不同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 3
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("既不同意也不反对")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 4
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("基本同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 5
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("完全同意")
                            ]),
                            _: 1
                          }, 8, ["style"])
                        ]),
                        _: 1
                      }, 8, ["value"]),
                      _createElementVNode("p", _hoisted_16, [
                        (_ctx.formState.string[4]!=null)
                          ? (_openBlock(), _createBlock(_component_a_button, {
                              key: 0,
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleSum(4)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("下一题")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["disabled"])),
                (_openBlock(), _createBlock(_component_a_tab_pane, {
                  key: 5,
                  tab: "5",
                  disabled: _ctx.formState.sum>=5? false:true
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.formState.ques[5]), 1),
                      _createVNode(_component_a_radio_group, {
                        value: _ctx.formState.string[5],
                        "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formState.string[5]) = $event)),
                        class: "QusRadio",
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handleSum(5)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 5
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("完全不同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 4
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("基本不同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 3
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("既不同意也不反对")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 2
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("基本同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 1
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("完全同意")
                            ]),
                            _: 1
                          }, 8, ["style"])
                        ]),
                        _: 1
                      }, 8, ["value"]),
                      _createElementVNode("p", _hoisted_18, [
                        (_ctx.formState.string[5]!=null)
                          ? (_openBlock(), _createBlock(_component_a_button, {
                              key: 0,
                              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.handleSum(5)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("下一题")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["disabled"])),
                (_openBlock(), _createBlock(_component_a_tab_pane, {
                  key: 6,
                  tab: "6",
                  disabled: _ctx.formState.sum>=6? false:true
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.formState.ques[6]), 1),
                      _createVNode(_component_a_radio_group, {
                        value: _ctx.formState.string[6],
                        "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formState.string[6]) = $event)),
                        class: "QusRadio",
                        onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.handleSum(6)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 5
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("完全不同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 4
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("基本不同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 3
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("既不同意也不反对")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 2
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("基本同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 1
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("完全同意")
                            ]),
                            _: 1
                          }, 8, ["style"])
                        ]),
                        _: 1
                      }, 8, ["value"]),
                      _createElementVNode("p", _hoisted_20, [
                        (_ctx.formState.string[6]!=null)
                          ? (_openBlock(), _createBlock(_component_a_button, {
                              key: 0,
                              onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.handleSum(6)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("下一题")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["disabled"])),
                (_openBlock(), _createBlock(_component_a_tab_pane, {
                  key: 7,
                  tab: "7",
                  disabled: _ctx.formState.sum>=7? false:true
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.formState.ques[7]), 1),
                      _createVNode(_component_a_radio_group, {
                        value: _ctx.formState.string[7],
                        "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formState.string[7]) = $event)),
                        class: "QusRadio",
                        onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.handleSum(7)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 1
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("完全不同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 2
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("基本不同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 3
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("既不同意也不反对")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 4
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("基本同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 5
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("完全同意")
                            ]),
                            _: 1
                          }, 8, ["style"])
                        ]),
                        _: 1
                      }, 8, ["value"]),
                      _createElementVNode("p", _hoisted_22, [
                        (_ctx.formState.string[7]!=null)
                          ? (_openBlock(), _createBlock(_component_a_button, {
                              key: 0,
                              onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.handleSum(7)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("下一题")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["disabled"])),
                (_openBlock(), _createBlock(_component_a_tab_pane, {
                  key: 8,
                  tab: "8",
                  disabled: _ctx.formState.sum>=8? false:true
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.formState.ques[8]), 1),
                      _createVNode(_component_a_radio_group, {
                        value: _ctx.formState.string[8],
                        "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formState.string[8]) = $event)),
                        class: "QusRadio",
                        onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.handleSum(8)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 1
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("完全不同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 2
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("基本不同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 3
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("既不同意也不反对")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 4
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("基本同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 5
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("完全同意")
                            ]),
                            _: 1
                          }, 8, ["style"])
                        ]),
                        _: 1
                      }, 8, ["value"]),
                      _createElementVNode("p", _hoisted_24, [
                        (_ctx.formState.string[8]!=null)
                          ? (_openBlock(), _createBlock(_component_a_button, {
                              key: 0,
                              onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.handleSum(8)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("下一题")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["disabled"])),
                (_openBlock(), _createBlock(_component_a_tab_pane, {
                  key: 9,
                  tab: "9",
                  disabled: _ctx.formState.sum>=9? false:true
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.formState.ques[9]), 1),
                      _createVNode(_component_a_radio_group, {
                        value: _ctx.formState.string[9],
                        "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formState.string[9]) = $event)),
                        class: "QusRadio",
                        onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.handleSum(9)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 1
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("完全不同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 2
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("基本不同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 3
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("既不同意也不反对")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 4
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("基本同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 5
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("完全同意")
                            ]),
                            _: 1
                          }, 8, ["style"])
                        ]),
                        _: 1
                      }, 8, ["value"]),
                      _createElementVNode("p", _hoisted_26, [
                        (_ctx.formState.string[9]!=null)
                          ? (_openBlock(), _createBlock(_component_a_button, {
                              key: 0,
                              onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.handleSum(9)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("下一题")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["disabled"])),
                (_openBlock(), _createBlock(_component_a_tab_pane, {
                  key: 10,
                  tab: "10",
                  disabled: _ctx.formState.sum>=10? false:true
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.formState.ques[10]), 1),
                      _createVNode(_component_a_radio_group, {
                        value: _ctx.formState.string[10],
                        "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.formState.string[10]) = $event)),
                        class: "QusRadio"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 1
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("完全不同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 2
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("基本不同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 3
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("既不同意也不反对")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 4
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("基本同意")
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          _createVNode(_component_a_radio, {
                            style: _normalizeStyle(_ctx.radioSt),
                            value: 5
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("完全同意")
                            ]),
                            _: 1
                          }, 8, ["style"])
                        ]),
                        _: 1
                      }, 8, ["value"]),
                      _createElementVNode("p", _hoisted_28, [
                        (_ctx.formState.string[10]!=null)
                          ? (_openBlock(), _createBlock(_component_a_button, {
                              key: 0,
                              onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.handleSum(10)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("下一版")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              ]),
              _: 1
            }, 8, ["activeKey"])
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(_component_a_col, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_tabs, {
            activeKey: _ctx.formState.activeKey,
            "onUpdate:activeKey": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.formState.activeKey) = $event)),
            type: "line",
            size: "small",
            tabBarGutter: 18,
            centered: true,
            style: {"background":"rgb(255, 255, 255)","min-width":"348px","padding":"20px","margin":"0px -10px","min-height":"450px"}
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: 11,
                tab: "11",
                disabled: _ctx.formState.sum>=11? false:true
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.formState.ques[11]), 1),
                    _createVNode(_component_a_radio_group, {
                      value: _ctx.formState.string[11],
                      "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.formState.string[11]) = $event)),
                      class: "QusRadio",
                      onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.handleSum(11)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 5
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 4
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 3
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("既不同意也不反对")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 1
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全同意")
                          ]),
                          _: 1
                        }, 8, ["style"])
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createElementVNode("p", _hoisted_30, [
                      (_ctx.formState.string[11]!=null)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.handleSum(11)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("下一题")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["disabled"])),
              (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: 12,
                tab: "12",
                disabled: _ctx.formState.sum>=12? false:true
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.formState.ques[12]), 1),
                    _createVNode(_component_a_radio_group, {
                      value: _ctx.formState.string[12],
                      "onUpdate:value": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.formState.string[12]) = $event)),
                      class: "QusRadio",
                      onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.handleSum(12)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 5
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 4
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 3
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("既不同意也不反对")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 1
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全同意")
                          ]),
                          _: 1
                        }, 8, ["style"])
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createElementVNode("p", _hoisted_32, [
                      (_ctx.formState.string[12]!=null)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.handleSum(12)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("下一题")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["disabled"])),
              (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: 13,
                tab: "13",
                disabled: _ctx.formState.sum>=13? false:true
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.formState.ques[13]), 1),
                    _createVNode(_component_a_radio_group, {
                      value: _ctx.formState.string[13],
                      "onUpdate:value": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.formState.string[13]) = $event)),
                      class: "QusRadio",
                      onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.handleSum(13)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 5
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 4
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 3
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("既不同意也不反对")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 1
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全同意")
                          ]),
                          _: 1
                        }, 8, ["style"])
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createElementVNode("p", _hoisted_34, [
                      (_ctx.formState.string[13]!=null)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.handleSum(13)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("下一题")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["disabled"])),
              (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: 14,
                tab: "14",
                disabled: _ctx.formState.sum>=14? false:true
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.formState.ques[14]), 1),
                    _createVNode(_component_a_radio_group, {
                      value: _ctx.formState.string[14],
                      "onUpdate:value": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.formState.string[14]) = $event)),
                      class: "QusRadio",
                      onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.handleSum(14)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 1
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 3
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("既不同意也不反对")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 4
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 5
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全同意")
                          ]),
                          _: 1
                        }, 8, ["style"])
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createElementVNode("p", _hoisted_36, [
                      (_ctx.formState.string[14]!=null)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.handleSum(14)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("下一题")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["disabled"])),
              (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: 15,
                tab: "15",
                disabled: _ctx.formState.sum>=15? false:true
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.formState.ques[15]), 1),
                    _createVNode(_component_a_radio_group, {
                      value: _ctx.formState.string[15],
                      "onUpdate:value": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.formState.string[15]) = $event)),
                      class: "QusRadio",
                      onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.handleSum(15)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 5
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 4
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 3
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("既不同意也不反对")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 1
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全同意")
                          ]),
                          _: 1
                        }, 8, ["style"])
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createElementVNode("p", _hoisted_38, [
                      (_ctx.formState.string[15]!=null)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.handleSum(15)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("下一题")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["disabled"])),
              (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: 16,
                tab: "16",
                disabled: _ctx.formState.sum>=16? false:true
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.formState.ques[16]), 1),
                    _createVNode(_component_a_radio_group, {
                      value: _ctx.formState.string[16],
                      "onUpdate:value": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.formState.string[16]) = $event)),
                      class: "QusRadio",
                      onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.handleSum(16)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 5
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 4
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 3
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("既不同意也不反对")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 1
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全同意")
                          ]),
                          _: 1
                        }, 8, ["style"])
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createElementVNode("p", _hoisted_40, [
                      (_ctx.formState.string[16]!=null)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.handleSum(16)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("下一题")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["disabled"])),
              (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: 17,
                tab: "17",
                disabled: _ctx.formState.sum>=17? false:true
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.formState.ques[17]), 1),
                    _createVNode(_component_a_radio_group, {
                      value: _ctx.formState.string[17],
                      "onUpdate:value": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.formState.string[17]) = $event)),
                      class: "QusRadio",
                      onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.handleSum(17)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 1
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 3
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("既不同意也不反对")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 4
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 5
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全同意")
                          ]),
                          _: 1
                        }, 8, ["style"])
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createElementVNode("p", _hoisted_42, [
                      (_ctx.formState.string[17]!=null)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.handleSum(17)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("下一题")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["disabled"])),
              (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: 18,
                tab: "18",
                disabled: _ctx.formState.sum>=18? false:true
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.formState.ques[18]), 1),
                    _createVNode(_component_a_radio_group, {
                      value: _ctx.formState.string[18],
                      "onUpdate:value": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.formState.string[18]) = $event)),
                      class: "QusRadio",
                      onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.handleSum(18)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 1
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 3
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("既不同意也不反对")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 4
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 5
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全同意")
                          ]),
                          _: 1
                        }, 8, ["style"])
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createElementVNode("p", _hoisted_44, [
                      (_ctx.formState.string[18]!=null)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            onClick: _cache[57] || (_cache[57] = ($event: any) => (_ctx.handleSum(18)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("下一题")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["disabled"])),
              (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: 19,
                tab: "19",
                disabled: _ctx.formState.sum>=19? false:true
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.formState.ques[19]), 1),
                    _createVNode(_component_a_radio_group, {
                      value: _ctx.formState.string[19],
                      "onUpdate:value": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.formState.string[19]) = $event)),
                      class: "QusRadio",
                      onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.handleSum(19)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 1
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 3
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("既不同意也不反对")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 4
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 5
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全同意")
                          ]),
                          _: 1
                        }, 8, ["style"])
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createElementVNode("p", _hoisted_46, [
                      (_ctx.formState.string[19]!=null)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.handleSum(19)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("下一题")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["disabled"])),
              (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: 20,
                tab: "20",
                disabled: _ctx.formState.sum>=20? false:true
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.formState.ques[20]), 1),
                    _createVNode(_component_a_radio_group, {
                      value: _ctx.formState.string[20],
                      "onUpdate:value": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.formState.string[20]) = $event)),
                      class: "QusRadio"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 1
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 3
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("既不同意也不反对")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 4
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 5
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全同意")
                          ]),
                          _: 1
                        }, 8, ["style"])
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createElementVNode("p", _hoisted_48, [
                      (_ctx.formState.string[20]!=null)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            onClick: _cache[62] || (_cache[62] = ($event: any) => (_ctx.handleSum(20)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("下一版")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["disabled"]))
            ]),
            _: 1
          }, 8, ["activeKey"])
        ]),
        _: 1
      }, 512), [
        [_vShow, _ctx.formState.list==2]
      ]),
      _withDirectives(_createVNode(_component_a_col, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_tabs, {
            activeKey: _ctx.formState.activeKey,
            "onUpdate:activeKey": _cache[81] || (_cache[81] = ($event: any) => ((_ctx.formState.activeKey) = $event)),
            type: "line",
            size: "small",
            tabBarGutter: 18,
            centered: true,
            style: {"background":"rgb(255, 255, 255)","min-width":"348px","padding":"20px","margin":"0px -10px","min-height":"450px"}
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: 21,
                tab: "21",
                disabled: _ctx.formState.sum>=21? false:true
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.formState.ques[21]), 1),
                    _createVNode(_component_a_radio_group, {
                      value: _ctx.formState.string[21],
                      "onUpdate:value": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.formState.string[21]) = $event)),
                      class: "QusRadio",
                      onClick: _cache[65] || (_cache[65] = ($event: any) => (_ctx.handleSum(21)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 5
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 4
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 3
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("既不同意也不反对")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 1
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全同意")
                          ]),
                          _: 1
                        }, 8, ["style"])
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createElementVNode("p", _hoisted_50, [
                      (_ctx.formState.string[21]!=null)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            onClick: _cache[66] || (_cache[66] = ($event: any) => (_ctx.handleSum(21)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("下一题")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["disabled"])),
              (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: 22,
                tab: "22",
                disabled: _ctx.formState.sum>=22? false:true
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.formState.ques[22]), 1),
                    _createVNode(_component_a_radio_group, {
                      value: _ctx.formState.string[22],
                      "onUpdate:value": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.formState.string[22]) = $event)),
                      class: "QusRadio",
                      onClick: _cache[68] || (_cache[68] = ($event: any) => (_ctx.handleSum(22)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 1
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 3
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("既不同意也不反对")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 4
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 5
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全同意")
                          ]),
                          _: 1
                        }, 8, ["style"])
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createElementVNode("p", _hoisted_52, [
                      (_ctx.formState.string[22]!=null)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            onClick: _cache[69] || (_cache[69] = ($event: any) => (_ctx.handleSum(22)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("下一题")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["disabled"])),
              (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: 23,
                tab: "23",
                disabled: _ctx.formState.sum>=23? false:true
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.formState.ques[23]), 1),
                    _createVNode(_component_a_radio_group, {
                      value: _ctx.formState.string[23],
                      "onUpdate:value": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.formState.string[23]) = $event)),
                      class: "QusRadio",
                      onClick: _cache[71] || (_cache[71] = ($event: any) => (_ctx.handleSum(23)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 1
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 3
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("既不同意也不反对")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 4
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 5
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全同意")
                          ]),
                          _: 1
                        }, 8, ["style"])
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createElementVNode("p", _hoisted_54, [
                      (_ctx.formState.string[23]!=null)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            onClick: _cache[72] || (_cache[72] = ($event: any) => (_ctx.handleSum(23)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("下一题")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["disabled"])),
              (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: 24,
                tab: "24",
                disabled: _ctx.formState.sum>=24? false:true
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.formState.ques[24]), 1),
                    _createVNode(_component_a_radio_group, {
                      value: _ctx.formState.string[24],
                      "onUpdate:value": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.formState.string[24]) = $event)),
                      class: "QusRadio",
                      onClick: _cache[74] || (_cache[74] = ($event: any) => (_ctx.handleSum(24)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 5
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 4
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 3
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("既不同意也不反对")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 1
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全同意")
                          ]),
                          _: 1
                        }, 8, ["style"])
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createElementVNode("p", _hoisted_56, [
                      (_ctx.formState.string[24]!=null)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            onClick: _cache[75] || (_cache[75] = ($event: any) => (_ctx.handleSum(24)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("下一题")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["disabled"])),
              (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: 25,
                tab: "25",
                disabled: _ctx.formState.sum>=25? false:true
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.formState.ques[25]), 1),
                    _createVNode(_component_a_radio_group, {
                      value: _ctx.formState.string[25],
                      "onUpdate:value": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.formState.string[25]) = $event)),
                      class: "QusRadio",
                      onClick: _cache[77] || (_cache[77] = ($event: any) => (_ctx.handleSum(25)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 1
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 3
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("既不同意也不反对")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 4
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 5
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全同意")
                          ]),
                          _: 1
                        }, 8, ["style"])
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createElementVNode("p", _hoisted_58, [
                      (_ctx.formState.string[25]!=null)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            onClick: _cache[78] || (_cache[78] = ($event: any) => (_ctx.handleSum(25)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("下一题")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["disabled"])),
              (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: 26,
                tab: "26",
                disabled: _ctx.formState.sum>=26? false:true
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.formState.ques[26]), 1),
                    _createVNode(_component_a_radio_group, {
                      value: _ctx.formState.string[26],
                      "onUpdate:value": _cache[79] || (_cache[79] = ($event: any) => ((_ctx.formState.string[26]) = $event)),
                      class: "QusRadio"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 1
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本不同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 3
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("既不同意也不反对")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 4
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("基本同意")
                          ]),
                          _: 1
                        }, 8, ["style"]),
                        _createVNode(_component_a_radio, {
                          style: _normalizeStyle(_ctx.radioSt),
                          value: 5
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完全同意")
                          ]),
                          _: 1
                        }, 8, ["style"])
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createElementVNode("p", _hoisted_60, [
                      (_ctx.formState.string[26]!=null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_61, "已完成（确认无误点击下面查询评估结果）"))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.formState.string[26]!=null)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_62, [
                          _createVNode(_component_a_button, {
                            onClick: _cache[80] || (_cache[80] = ($event: any) => (_ctx.handleSuccess(3)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("查询评估结果")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["disabled"]))
            ]),
            _: 1
          }, 8, ["activeKey"])
        ]),
        _: 1
      }, 512), [
        [_vShow, _ctx.formState.list==3]
      ]),
      _createElementVNode("p", _hoisted_63, _toDisplayString(_ctx.formState.sum) + "/26（" + _toDisplayString(_ctx.formState.list) + "页）", 1)
    ], 512), [
      [_vShow, _ctx.formState.onSuccess==2]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_64, [
      _createElementVNode("div", _hoisted_65, [
        _hoisted_66,
        _createElementVNode("table", _hoisted_68, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_69, [
              _createElementVNode("b", null, "1.您相对" + _toDisplayString(_ctx.formState.res1=='↑'?"[更难":"[能更好") + "描述自己的情感]", 1)
            ])
          ]),
          _createElementVNode("tr", _hoisted_70, [
            _createElementVNode("th", _hoisted_71, [
              _createElementVNode("b", {
                class: _normalizeClass(_ctx.formState.res1=='↑'?'fen yang':'fen ying')
              }, _toDisplayString(_ctx.formState.fen1), 3)
            ]),
            _createElementVNode("th", {
              width: "20",
              class: _normalizeClass(_ctx.formState.res1=='↑'?'tc yang':'tc ying')
            }, _toDisplayString(_ctx.formState.res1), 3),
            _createElementVNode("th", _hoisted_72, [
              _createTextVNode("本项代表着描述情感的能力。得分越高，障碍越明显。越难以描述自己的情感。"),
              (_ctx.formState.res1=='↑')
                ? (_openBlock(), _createElementBlock("span", _hoisted_73, "\"↑\"代表着，你在此项相比本站其他被测评人[更难描述或讲出自己的情感感受]。"))
                : _createCommentVNode("", true),
              (_ctx.formState.res1=='↓')
                ? (_openBlock(), _createElementBlock("span", _hoisted_74, "\"↓\"代表着，你在此项相比本站其他被测评人[更懂表达自己的情感]。"))
                : _createCommentVNode("", true),
              _createTextVNode("（n=15.2）")
            ])
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_75, [
              _createElementVNode("b", null, "2.您相对" + _toDisplayString(_ctx.formState.res2=='↑'?"[更难":"[能更好") + "区分自己的情感与躯体感受]", 1)
            ])
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, [
              _createElementVNode("b", {
                class: _normalizeClass(_ctx.formState.res2=='↑'?'fen yang':'fen ying')
              }, _toDisplayString(_ctx.formState.fen2), 3)
            ]),
            _createElementVNode("th", {
              class: _normalizeClass(_ctx.formState.res2=='↑'?'tc yang':'tc ying')
            }, _toDisplayString(_ctx.formState.res2), 3),
            _createElementVNode("th", _hoisted_76, [
              _createTextVNode("本项代表着辨别自己的感觉是来源于情感还是躯体的感受。得分越高，辨别的障碍越明显。"),
              (_ctx.formState.res2=='↑')
                ? (_openBlock(), _createElementBlock("span", _hoisted_77, "\"↑\"代表着，你在此项相比本站其他被测评人[更难区分自己的感受]。"))
                : _createCommentVNode("", true),
              (_ctx.formState.res2=='↓')
                ? (_openBlock(), _createElementBlock("span", _hoisted_78, "\"↓\"代表着，你在此项相比本站其他被测评人[更懂区分自己的感受]。"))
                : _createCommentVNode("", true),
              _createTextVNode("（n=17.7）")
            ])
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_79, [
              _createElementVNode("b", null, "3.您相对" + _toDisplayString(_ctx.formState.res3=='↑'?"[缺乏":"[有更多") + "情感幻想的能力]", 1)
            ])
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, [
              _createElementVNode("b", {
                class: _normalizeClass(_ctx.formState.res3=='↑'?'fen yang':'fen ying')
              }, _toDisplayString(_ctx.formState.fen3), 3)
            ]),
            _createElementVNode("th", {
              class: _normalizeClass(_ctx.formState.res3=='↑'?'tc yang':'tc ying')
            }, _toDisplayString(_ctx.formState.res3), 3),
            _createElementVNode("th", _hoisted_80, [
              _createTextVNode("本项代表着幻想能力的多与少。得分越高，情感幻想越少，更为理性。"),
              (_ctx.formState.res3=='↑')
                ? (_openBlock(), _createElementBlock("span", _hoisted_81, "\"↑\"代表着，你在此项相比本站其他被测评人[具备更少的幻想]。"))
                : _createCommentVNode("", true),
              (_ctx.formState.res3=='↓')
                ? (_openBlock(), _createElementBlock("span", _hoisted_82, "\"↓\"代表着，你在此项相比本站其他被测评人[具备更多的幻想]。"))
                : _createCommentVNode("", true),
              _createTextVNode("（n=12.7）")
            ])
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_83, [
              _createElementVNode("b", null, "4.您相对" + _toDisplayString(_ctx.formState.res4=='↑'?"缺乏":"有更多") + "外向性思维", 1)
            ])
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, [
              _createElementVNode("b", {
                class: _normalizeClass(_ctx.formState.res4=='↑'?'fen yang':'fen ying')
              }, _toDisplayString(_ctx.formState.fen4), 3)
            ]),
            _createElementVNode("th", {
              class: _normalizeClass(_ctx.formState.res4=='↑'?'tc yang':'tc ying')
            }, _toDisplayString(_ctx.formState.res4), 3),
            _createElementVNode("th", _hoisted_84, [
              _createTextVNode("本项代表着你的外向性思维。得分越高，外向性思维的障碍越明显。"),
              (_ctx.formState.res4=='↑')
                ? (_openBlock(), _createElementBlock("span", _hoisted_85, "\"↑\"代表着，你在此项相比本站其他被测评人[更难表现出感情外露，热情、活泼、开朗、善于交际、适应环境的能力]。"))
                : _createCommentVNode("", true),
              (_ctx.formState.res4=='↓')
                ? (_openBlock(), _createElementBlock("span", _hoisted_86, "\"↓\"代表着，你在此项相比本站其他被测评人[更能表现出感情外露，热情、活泼、开朗、善于交际、适应环境的能力]。"))
                : _createCommentVNode("", true),
              _createTextVNode("（n=20.3）")
            ])
          ])
        ])
      ])
    ], 512), [
      [_vShow, _ctx.formState.onSuccess==3]
    ])
  ]))
}